
let searchTimeout;
let currentHeaderbar;

document.addEventListener('DOMContentLoaded', () => {

    let headerbars = document.querySelectorAll('.js-headerbar');

    const searchFormInput = document.querySelectorAll('.js-search-form-input');

    searchFormInput.forEach(input => {
        input.addEventListener('keyup', (event) => {
            let headerbar = event.target.closest('.js-headerbar');
            debouncedSearch(event.target.value, headerbar);
        });
    });

    // Close search results on click outside
    headerbars.forEach(headerbar => {
        headerbar.addEventListener('click', (event) => {
        if(!event.target.closest('.js-search-form')) {
                headerbar.querySelector('.js-search-results').classList.remove('active');
            }
        });
        headerbar.querySelector('.js-headerbar-search-icon').addEventListener('click', () => openSearch(headerbar));
    });

});
                    
function debounce(func, wait) {
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(searchTimeout);
            func(...args);
        };
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(later, wait);
    };
}

function search(query, container) {
    currentHeaderbar = container;
    const searchResults = container.querySelector('.js-search-results');
    if(!query.length) {
        searchResults.classList.remove('active');
        return;
    }else if(query.length > 2) {
        searchResults.classList.add('active');
        searchResults.innerHTML = '<div class="search-results-title">Recherche en cours...</div>';
        fetch(`/mag/search?q=${query}`)
        .then(response => response.text())
        .then(data => {
            const searchResults = container.querySelector('.js-search-results');
            searchResults.innerHTML = data;
        });
    }
}

const debouncedSearch = debounce(search, 300);

function openSearch(container) {
    container.querySelector('.js-search-form').style.display = 'block';
    container.querySelector('.js-headerbar-logo').style.display = 'none';
    container.querySelector('.js-headerbar-search-icon').style.display = 'none';
    container.querySelector('.js-headerbar-item-phone').style.display = 'none';
    container.querySelector('.js-search-form input').focus();
    searchIsOpen = true;
}

function closeSearch() {

    if(!currentHeaderbar) {
        return;
    }

    currentHeaderbar.querySelector('.js-search-form').style = '';
    currentHeaderbar.querySelector('.js-headerbar-logo').style = '';
    currentHeaderbar.querySelector('.js-headerbar-search-icon').style = '';
    currentHeaderbar.querySelector('.js-headerbar-item-phone').style = '';
    currentHeaderbar.querySelector('.js-search-results').classList.remove('active');
    currentHeaderbar = null;
}

// Close search results if the user clicks outside the search form
// Do not trigger if clicking search results
document.addEventListener('click', (event) => {
    const inSearchResults = event.target.closest('.js-search-results');
    const inSearchForm = event.target.closest('.js-search-form');

    if(!inSearchResults && !inSearchForm) {
        closeSearch();
    }
});


